import {
  useMediaLibImportImages,
  useMediaLibPanelStoreShallow,
} from "@editor/modules/media-lib";

interface IProps {
  onUploadStart?: () => void;
}

export const useMediaLibPanelImportImages = ({
  onUploadStart,
}: IProps = {}) => {
  const { setFiles, setCategory, setSelectedFolderId } =
    useMediaLibPanelStoreShallow((s) => ({
      setSelectedFolderId: s.setSelectedFolderId,
      setFiles: s.setFiles,
      setCategory: s.setCategory,
    }));

  return useMediaLibImportImages({
    onUploadStart,
    setCategory,
    setSelectedFolderId,
    onAddFiles: (files) => setFiles({ files, extend: true }),
  });
};
